import { gql } from '../../../../types/__codegen__/ahm-api';

export const GET_SERVICES = gql(`
  query GetServices($input: ServiceInput) {
    getServices(input: $input) {
      description
      name
      serviceId
    }
  }
`);
